import React from 'react';
import PropTypes from 'prop-types';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
const MotifHeaderLogo = ({ children }) => <div className="motif-header-logo" data-motif-header-logo>{children}</div>;

MotifHeaderLogo.propTypes = {
  children: PropTypes.node
};

export { MotifHeaderLogo };
